import { toast } from "react-toastify";
import { action, observable } from "mobx";
import { api } from "../../api";
import { ICalc, IEmpresa, IMemoria, IMemoriaCalculo, newEmpresa, newIMemoria } from "../../model";
import { decodeUtf8String, downloadBinaryFile } from "../../utils";

export class _MemoriaStore {
  obs = observable({
    selectedTab: "nfe" as string,
    memoria_calculo: [] as IMemoriaCalculo[],
    memoria_length: 0 as number,
    current_page: 1 as number,
    modelo: "nfe" as string,
    loading: false as boolean,
    filters: {
      "cest": "",
      "ncm": "",
      "cfop": "",
      "cnpj_origem": "",
      "cnpj_destino": "",
      "descricao": "",
      "cod_trib_nacional": "",
    },
    estado: "PA" as string,
    entrada_saida: "entrada" as string,
    deletarMemorias: [] as any,
    loading_delete: false as boolean,
    select_empresa: newEmpresa() as IEmpresa,
    open_create: false as boolean,
    create_memoria: newIMemoria() as IMemoria,
    calcOptions: [] as any,
    calc_selecionado: null as ICalc,
    open_ajuda: false as boolean,
    tasks_relatorio: [] as any[],
    length_tasks_relatorio: 0 as number,
    date_start: "" as string,
    date_end: "" as string,
    open_erros_relatorio: false as boolean,
  })

  resetFilters() {
    this.obs.filters = {
      "cest": "",
      "ncm": "",
      "cfop": "",
      "cnpj_origem": "",
      "cnpj_destino": "",
      "descricao": "",
      "cod_trib_nacional": "",
    }
  }

  async handleMemorias(params) {

    try {

      let resp = await api.post("/api/memoria-contestacoes", params);

      if (resp.data.itens.length > 0) {

        this.obs.memoria_length = resp.data.count
        this.obs.memoria_calculo = resp.data.itens;

      } else {

        this.obs.memoria_length = 0
        this.obs.current_page = 1
        this.obs.memoria_calculo = [];

      }

    } catch (ex) {

      toast.error("Erro ao filtrar Memória Contestações, tente novamente mais tarde.", {});

    }

  }
  resetDeletarItems() {
    this.obs.deletarMemorias = [];
  }

  async handleDeleteMemorias() {

    this.obs.loading_delete = true

    try {

      let resp = await api.post('/api/memoria-contestacoes/delete', { memorias: this.obs.deletarMemorias, modelo: this.obs.modelo })

      if (resp.data.ok) {

        toast.success(`Memórias deletadas com sucesso!`, {});

        this.obs.deletarMemorias = []

        this.obs.loading_delete = false

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Erro ao deletar Lote Memória Contestações, tente novamente mais tarde.", {});

    }

    this.obs.loading_delete = false

    return false

  }

  async handleCreateMemoria(data) {

    try {

      let resp = await api.post('/api/memoria-contestacoes/create', data)

      if (resp.data.ok) {

        toast.success(`Memória criada com sucesso!`, {});

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Erro ao deletar Lote Memória Contestações, tente novamente mais tarde.", {});

    }

    return false

  }

  async handleUpdateMemoria(data) {

    try {

      let resp = await api.post('/api/memoria-contestacoes/update', data)

      if (resp.data.ok) {

        toast.success(`Memória criada com sucesso!`, {});

        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Erro ao deletar Lote Memória Contestações, tente novamente mais tarde.", {});

    }

    return false

  }

  async handleExport(params) {

    try {

      let resp = await api.post("/api/memoria-contestacoes/export/create", params);

      if (resp.data.ok) {

        toast.success(`Solicitação realizada com sucesso.`, {});
        return true

      } else {

        toast.error(resp.data.erro, {});
      }

    } catch (ex) {

      toast.error(`Erro ao exportar arquivo, tente novamente mais tarde.`, {});

    }

    return false

  }

  async handleTasksPaged(paged: number, cnpj: string, data_inicio: string, data_fim: string, modelo: string, tipo: string) {

    try {

      let data = {
        page: paged,
        limit: 15,
        cnpj: cnpj,
        date_start: data_inicio,
        date_end: data_fim,
        modelo: modelo,
        tipo: tipo
      }

      let resp = await api.post("/api/memoria-contestacoes/export/index", data);

      this.obs.tasks_relatorio = [];
      this.obs.length_tasks_relatorio = 0

      if (resp.data.itens.length > 0) {

        this.obs.tasks_relatorio = resp.data.itens
        this.obs.length_tasks_relatorio = resp.data.count

      }

    } catch (ex) {

      toast.error("Erro ao Carregar Relatórios, tente novamente mais tarde.", {});

    }

  }

  async handleDownloadArquivoRelatorio(id: string, cnpj: string, format: string) {

    this.obs.loading = true

    try {

      let resp = await api.post(`/api/relatorio/task/download`, { id: id, format: format }, { responseType: 'blob' });

      if (resp.status == 200) {

        const fileName = cnpj + "_relatorio." + format;

        downloadBinaryFile(resp.data, fileName)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) {

      toast.error('erro ao baixar o arquivo, tente novamente mais tarde ou contate o suporte.', {});

    }

    this.obs.loading = false

  }

}

export const MemoriaStore = new _MemoriaStore();
